import { Component, OnInit, ViewChild, NgZone } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Router } from '@angular/router';
import { GeneralService } from '../services/general.service';
import { GooglePlaceDirective } from 'ngx-google-places-autocomplete';
import { FormControl, NgForm } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatFormField } from '@angular/material/form-field';
import { AvtListesComponent } from '../avt-listes/avt-listes.component';
import { AvtDialogDeleteComponent } from '../avt-dialog-delete/avt-dialog-delete.component';
declare var $: any;
@Component({
  selector: 'app-client',
  templateUrl: './client.component.html',
  styleUrls: ['./client.component.css'],
})
export class ClientComponent implements OnInit {
  //************ */ajouter***********  typeTrs=1
  //************ */modifier**********  typeTrs=2
  //************ */consulter*********  typeTrs=3

  //@ViewChild//
  @ViewChild(GooglePlaceDirective, { static: true })
  placesRef: GooglePlaceDirective;
  //@ViewChild//
  @ViewChild('formIniformation', { static: false }) formIniformation: NgForm;
  @ViewChild('listeInterlocuteurComponen', { static: false })
  listeInterlocuteurComponen: AvtListesComponent;
  @ViewChild('listeActionComponen', { static: false })
  listeActionComponen: AvtListesComponent;
  @ViewChild('listeDevisComponen', { static: false })
  listeDevisComponen: AvtListesComponent;
  @ViewChild('listeFactureComponen', { static: false })
  listeFactureComponen: AvtListesComponent;
  pattern: string | RegExp;
  username = new FormControl();
  componentForm = this.generalService.componentForm;

  typeClient = '1';
  typeClientText = 'clients';
  typeTrs;
  param_code;
  buttonDisabled = false;
  disabled = false;
  show = true;
  ds;
  data;
  url = this.generalService.urlClient;
  clientIsLoadet = false;
  pays;
  index = 0;
  oldIndex = 0;
  datasourceInterlocuteur = [];
  datasourceInterlocuteurIsLoadet: boolean = false;
  listBtnInterlocuteur: Array<any> = [];
  list_Btn_Inter_locuteur: Array<any> = [
    {
      name: 'ajouter',
      class: 'colorBlue',
      text: 'Ajouter',
      disabled: false,
      icon: 'add',
    },
    {
      name: 'modifier',
      class: 'colorGreen',
      text: 'Modifier',
      disabled: false,
      icon: 'edite',
    },
    {
      name: 'supprimer',
      class: 'colorRed',
      text: 'Supprimer',
      disabled: false,
      icon: 'delete',
    },
  ];
  columnsInterlocuteur = { TableRD: [] };
  columnsInterlocuteurIsLoadet: boolean = false;
  listeTypeClient = [
    {
      DiverSys_Index: '1',
      DiverSys_Titre: 'CLIENT',
    },
    {
      DiverSys_Index: '2',
      DiverSys_Titre: 'Prospect',
    },
    {
      DiverSys_Index: '3',
      DiverSys_Titre: 'Fournisseur',
    },
  ];
  disabledInterlocuteur: boolean = true;
  disabledEchanges: boolean = true;
  disabledEAlertes: boolean = true;
  disabledEDocuments: boolean = true;
  showTabEchange: boolean = false;
  exist: boolean = false;
  showDoc: boolean = false;
  showTabInterlocuteur: boolean = false;
  showTabAlert: boolean = false;
  ckeConfig = {
    allowedContent: false,
    extraPlugins: 'divarea',
    forcePasteAsPlainText: true,
  };
  selectedTiersFacturation;
  avatarSrc: string = '../../assets/avatar.png';
  haveImage = false;
  imageName: string = '';
  imageSrc: string = '';
  imageType: string = '';
  imageClient;
  numberFileToSave: number = 0;
  columnsDevis = {
    TableRD: [
      {
        TableRE_Code: '',
        TableRD_Champs: 'Doc_Num',
        Lg_Code: '',
        TableRD_Des: 'Code',
        TableRD_Largeur: 70,
        TableRD_ReadOnly: true,
        TableRD_Format: '',
        TableRD_Alligement: 0,
        TableRD_Ordre: 0,
        TableRD_Type: 0,
        TableRD_Param1: null,
        TableRD_Param2: null,
        TableRD_ValDef: null,
        TableRD_Tri: true,
        TableRD_Valid: null,
        TableRD_ValidType: 0,
        TableRD_ExpressionH: null,
        TableRD_ExpressionR: null,
        User_Id: '*',
        User_Groupe: null,
      },
      {
        TableRE_Code: '',
        TableRD_Champs: 'Doc_Date',
        Lg_Code: '',
        TableRD_Des: 'Date',
        TableRD_Largeur: 100,
        TableRD_ReadOnly: true,
        TableRD_Format: 'dd-MM-yyyy',
        TableRD_Alligement: 0,
        TableRD_Ordre: 0,
        TableRD_Type: 4,
        TableRD_Param1: null,
        TableRD_Param2: null,
        TableRD_ValDef: null,
        TableRD_Tri: true,
        TableRD_Valid: null,
        TableRD_ValidType: 0,
        TableRD_ExpressionH: null,
        TableRD_ExpressionR: null,
        User_Id: '*',
        User_Groupe: null,
      },
      {
        TableRE_Code: '',
        TableRD_Champs: 'Doc_TTTC',
        Lg_Code: '',
        TableRD_Des: 'Montant HT',
        TableRD_Largeur: 70,
        TableRD_ReadOnly: true,
        TableRD_Format: '',
        TableRD_Alligement: 0,
        TableRD_Ordre: 0,
        TableRD_Type: 0,
        TableRD_Param1: null,
        TableRD_Param2: null,
        TableRD_ValDef: null,
        TableRD_Tri: true,
        TableRD_Valid: null,
        TableRD_ValidType: 0,
        TableRD_ExpressionH: null,
        TableRD_ExpressionR: null,
        User_Id: '*',
        User_Groupe: null,
      },
    ],
  };
  columnsFacture = {
    TableRD: [
      {
        TableRE_Code: '',
        TableRD_Champs: 'Doc_Num',
        Lg_Code: '',
        TableRD_Des: 'Code',
        TableRD_Largeur: 70,
        TableRD_ReadOnly: true,
        TableRD_Format: '',
        TableRD_Alligement: 0,
        TableRD_Ordre: 0,
        TableRD_Type: 0,
        TableRD_Param1: null,
        TableRD_Param2: null,
        TableRD_ValDef: null,
        TableRD_Tri: true,
        TableRD_Valid: null,
        TableRD_ValidType: 0,
        TableRD_ExpressionH: null,
        TableRD_ExpressionR: null,
        User_Id: '*',
        User_Groupe: null,
      },
      {
        TableRE_Code: '',
        TableRD_Champs: 'Doc_Date',
        Lg_Code: '',
        TableRD_Des: 'Date',
        TableRD_Largeur: 100,
        TableRD_ReadOnly: true,
        TableRD_Format: 'dd-MM-yyyy',
        TableRD_Alligement: 0,
        TableRD_Ordre: 0,
        TableRD_Type: 4,
        TableRD_Param1: null,
        TableRD_Param2: null,
        TableRD_ValDef: null,
        TableRD_Tri: true,
        TableRD_Valid: null,
        TableRD_ValidType: 0,
        TableRD_ExpressionH: null,
        TableRD_ExpressionR: null,
        User_Id: '*',
        User_Groupe: null,
      },
      {
        TableRE_Code: '',
        TableRD_Champs: 'Doc_TTTC',
        Lg_Code: '',
        TableRD_Des: 'Montant HT',
        TableRD_Largeur: 70,
        TableRD_ReadOnly: true,
        TableRD_Format: '',
        TableRD_Alligement: 0,
        TableRD_Ordre: 0,
        TableRD_Type: 0,
        TableRD_Param1: null,
        TableRD_Param2: null,
        TableRD_ValDef: null,
        TableRD_Tri: true,
        TableRD_Valid: null,
        TableRD_ValidType: 0,
        TableRD_ExpressionH: null,
        TableRD_ExpressionR: null,
        User_Id: '*',
        User_Groupe: null,
      },
      {
        TableRE_Code: '',
        TableRD_Champs: 'Doc_Reliquat',
        Lg_Code: '',
        TableRD_Des: 'Reliquat',
        TableRD_Largeur: 70,
        TableRD_ReadOnly: true,
        TableRD_Format: '',
        TableRD_Alligement: 0,
        TableRD_Ordre: 0,
        TableRD_Type: 0,
        TableRD_Param1: null,
        TableRD_Param2: null,
        TableRD_ValDef: null,
        TableRD_Tri: true,
        TableRD_Valid: null,
        TableRD_ValidType: 0,
        TableRD_ExpressionH: null,
        TableRD_ExpressionR: null,
        User_Id: '*',
        User_Groupe: null,
      },
      {
        TableRE_Code: '',
        TableRD_Champs: 'state',
        Lg_Code: '',
        TableRD_Des: 'État',
        TableRD_Largeur: 70,
        TableRD_ReadOnly: true,
        TableRD_Format: '',
        TableRD_Alligement: 0,
        TableRD_Ordre: 0,
        TableRD_Type: 7,
        TableRD_Param1: null,
        TableRD_Param2: null,
        TableRD_ValDef: null,
        TableRD_Tri: true,
        TableRD_Valid: null,
        TableRD_ValidType: 0,
        TableRD_ExpressionH: null,
        TableRD_ExpressionR: null,
        User_Id: '*',
        User_Groupe: null,
      },
    ],
  };
  columnsAction = {
    TableRD: [
      {
        TableRE_Code: '',
        TableRD_Champs: 'avtAction_Code',
        Lg_Code: '',
        TableRD_Des: 'Code',
        TableRD_Largeur: 70,
        TableRD_ReadOnly: true,
        TableRD_Format: '',
        TableRD_Alligement: 0,
        TableRD_Ordre: 0,
        TableRD_Type: 0,
        TableRD_Param1: null,
        TableRD_Param2: null,
        TableRD_ValDef: null,
        TableRD_Tri: true,
        TableRD_Valid: null,
        TableRD_ValidType: 0,
        TableRD_ExpressionH: null,
        TableRD_ExpressionR: null,
        User_Id: '*',
        User_Groupe: null,
      },
      {
        TableRE_Code: '',
        TableRD_Champs: 'avtAction_Intitule',
        Lg_Code: '',
        TableRD_Des: 'Intutilé',
        TableRD_Largeur: 350,
        TableRD_ReadOnly: true,
        TableRD_Format: '',
        TableRD_Alligement: 0,
        TableRD_Ordre: 1,
        TableRD_Type: 0,
        TableRD_Param1: null,
        TableRD_Param2: null,
        TableRD_ValDef: null,
        TableRD_Tri: true,
        TableRD_Valid: null,
        TableRD_ValidType: 0,
        TableRD_ExpressionH: null,
        TableRD_ExpressionR: null,
        User_Id: '*',
        User_Groupe: null,
      },
      {
        TableRE_Code: '',
        TableRD_Champs: 'Date_Create',
        Lg_Code: '',
        TableRD_Des: 'D.création',
        TableRD_Largeur: 120,
        TableRD_ReadOnly: true,
        TableRD_Format: 'dd-MM-yyyy',
        TableRD_Alligement: 0,
        TableRD_Ordre: 1,
        TableRD_Type: 4,
        TableRD_Param1: null,
        TableRD_Param2: null,
        TableRD_ValDef: null,
        TableRD_Tri: true,
        TableRD_Valid: null,
        TableRD_ValidType: 0,
        TableRD_ExpressionH: null,
        TableRD_ExpressionR: null,
        User_Id: '*',
        User_Groupe: null,
      },
      {
        TableRE_Code: '',
        TableRD_Champs: 'avtAction_dateDeb',
        Lg_Code: '',
        TableRD_Des: 'Debut',
        TableRD_Largeur: 100,
        TableRD_ReadOnly: true,
        TableRD_Format: 'dd-MM-yyyy',
        TableRD_Alligement: 0,
        TableRD_Ordre: 4,
        TableRD_Type: 4,
        TableRD_Param1: null,
        TableRD_Param2: null,
        TableRD_ValDef: null,
        TableRD_Tri: true,
        TableRD_Valid: null,
        TableRD_ValidType: 0,
        TableRD_ExpressionH: null,
        TableRD_ExpressionR: null,
        User_Id: '*',
        User_Groupe: null,
      },
      {
        TableRE_Code: '',
        TableRD_Champs: 'avtAction_dateFin',
        Lg_Code: '',
        TableRD_Des: 'Fin',
        TableRD_Largeur: 100,
        TableRD_ReadOnly: true,
        TableRD_Format: 'dd-MM-yyyy',
        TableRD_Alligement: 0,
        TableRD_Ordre: 5,
        TableRD_Type: 4,
        TableRD_Param1: null,
        TableRD_Param2: null,
        TableRD_ValDef: null,
        TableRD_Tri: true,
        TableRD_Valid: null,
        TableRD_ValidType: 0,
        TableRD_ExpressionH: null,
        TableRD_ExpressionR: null,
        User_Id: '*',
        User_Groupe: null,
      },
    ],
  };
  listeTypeEvennement = this.generalService.listeTypeEvennement;
  // listeEvennement = this.generalService.listeEvennement;
  listeTypeEvennementGroupe = [];
  constructor(
    public dialog: MatDialog,
    public ngZone: NgZone,
    public generalService: GeneralService,
    public router: Router,
    public route: ActivatedRoute
  ) {}
  ngOnInit(): void {
    this.data = {};
    this.readParamUrl();
    this.pays = this.generalService.nationalitePays;
    // this.genererListeTypeEvennementGroupe()
  }
  // genererListeTypeEvennementGroupe()
  // {
  //   this.listeTypeEvennement.forEach(typeEv =>
  //   {
  //     var liste = this.listeEvennement.filter(ev => {return ev.typeEvennemtCode == typeEv.typeEvennemtCode})
  //     var row = typeEv;
  //     row["listeEvennement"] = liste
  //     this.listeTypeEvennementGroupe.push(JSON.parse(JSON.stringify(row)))
  //   });
  // }
  selectImage() {
    if (!this.disabled) document.getElementById('imageFile').click();
  }
  saveImageClient(Perso_Matricule: string) {
    this.numberFileToSave++;
    //il ya une image à enregister
    if (this.imageName != '' && this.imageSrc != '') {
      //ajout
      if (this.typeTrs == '1') {
        this.addFiles(
          this.generalService.initDoc,
          this.imageSrc,
          this.imageName,
          Perso_Matricule,
          'client',
          null,
          'crerFichier',
          'avatar',
          '',
          this.imageType
        );
      }
      //modification
      else {
        this.generalService
          .rechercheTable(
            this.generalService.urlFindDoc +
              Perso_Matricule +
              ',' +
              'client' +
              ',' +
              'avatar'
          )
          .subscribe((imageClient) => {
            //le client à une encienne image à modifier => modifiction image
            if (imageClient.length > 0) {
              this.imageClient = imageClient[imageClient.length - 1];

              this.generalService
                .rechercheTable(
                  this.generalService.urlFiles +
                    '&val=' +
                    this.imageClient.File_Id
                )
                .subscribe((file) => {
                  file.Files[0].File_Text = this.imageName;
                  file.Files[0].File_Content = this.imageSrc;
                  file.Files[0].File_Autre = this.imageType;
                  this.generalService
                    .enregisterTable(file)
                    .subscribe((data) => {
                      this.numberFileToSave--;
                      this.showMsgEnressitrer();
                    });
                });
            }
            //le client n'a pas d'image => ajoute image
            else
              this.addFiles(
                this.generalService.initDoc,
                this.imageSrc,
                this.imageName,
                Perso_Matricule,
                'client',
                null,
                'crerFichier',
                'avatar',
                '',
                this.imageType
              );
          });
      }
    } else {
      this.numberFileToSave--;
      this.showMsgEnressitrer();
    }
  }
  showImage(code) {
    if (this.typeTrs != '1')
      this.generalService
        .rechercheTable(
          this.generalService.urlFindDoc +
            code +
            ',' +
            'client' +
            ',' +
            'avatar'
        )
        .subscribe(
          (data) => {
            const b64Data = data;
            if (b64Data != undefined && b64Data != null && b64Data.length > 0) {
              this.haveImage = true;
              this.avatarSrc =
                b64Data[b64Data.length - 1].File_Autre +
                b64Data[b64Data.length - 1].File_Content;
              this.imageClient = b64Data[b64Data.length - 1];
            } else this.haveImage = false;
          },
          (err) => {}
        );
    else this.avatarSrc = '../../assets/avatar.png';
  }
  onChangeImagefile(fileInput) {
    var reader2 = new FileReader();
    var src: string;
    this.haveImage = true;
    reader2.onload = (e) => {
      src = reader2.result.toString();
      // var image = document.getElementById("imageDiv");
      //image.setAttribute("src",src);
      this.avatarSrc = src;
      this.imageName = fileInput.target.files[0].name;
      this.imageType = src.substring(0, src.indexOf(',') + 1);
      this.imageSrc = src.replace(this.imageType, '');
      if (this.typeTrs == '2' || this.typeTrs == '10') {
        this.exist = false;
        this.saveImageClient(this.param_code);
      }
    };
    reader2.readAsDataURL(fileInput.target.files[0]);
  }

  addFiles(
    initDoc,
    File_Content,
    File_Text,
    File_Key,
    File_Type,
    File_Parent,
    clickMode,
    File_Groupe,
    File_Lien,
    File_Autre
  ) {
    var id;
    var doc = this.generalService.clone(initDoc);
    doc.files[0].File_Parent = File_Parent;
    doc.files[0].File_Content = File_Content;
    doc.files[0].File_Text = File_Text;
    doc.files[0].File_Key = File_Key;
    doc.files[0].File_Type = File_Type;
    doc.files[0].File_Groupe = File_Groupe;
    doc.files[0].File_Lien = File_Lien;
    doc.files[0].File_Autre = File_Autre;
    if (clickMode == 'crerFichier') {
      doc.files[0].File_Dll = 'jstree-file';
    }
    if (clickMode == 'crerDossier') {
      doc.files[0].File_Dll = 'jstree-folder';
    }
    this.generalService.enregisterTable(doc).subscribe((data) => {
      this.numberFileToSave--;
      this.showMsgEnressitrer();
    });
    return id;
  }
  showMsgEnressitrer() {
    if (this.numberFileToSave == 0) {
      this.generalService.dialogSuccess('Enregistré', true);
      this.exist = true;
    }
  }
  openFrmNewEntiterFacturation() {
    if (this.typeTrs != '3') {
      // this.generalService.param_code = "1";
      // this.generalService.typeTrs = "1";
      this.generalService.popupCenter('/w/avt/client/1/1/' + this.typeClient);
      // this.generalService.dialogOpend = this.generalService.dialog.open(ClientComponent, new MatDialogConfig());
      // this.generalService.dialogOpend.afterClosed().subscribe(() =>
      // {
      //   this.generalService.param_code = null;
      //   this.generalService.typeTrs = null;
      // });
    }
  }
  setTypeClientText() {
    if (this.typeClient == '2') this.typeClientText = 'PROSPECT';
    else if (this.typeClient == '1') this.typeClientText = 'CLIENTS';
    else if (this.typeClient == '3') this.typeClientText = 'Fournisseur';
  }

  blurChamp(event) {
    this.data.Tiers_codeF = event;
  }
  getClient() {
    this.setTypeClientText();
    if (this.typeTrs == '1') {
      this.httpGet(this.url);
    }
    if (this.typeTrs == '2' || this.typeTrs == '3') {
      this.disabledEAlertes = false;
      this.disabledEDocuments = false;
      this.disabledEchanges = false;
      this.disabledInterlocuteur = false;
      this.showTabAlert = true;
      this.showTabEchange = true;
      this.httpGet(this.url + '&val=' + this.param_code);
    }
    if (this.typeTrs == '3') {
      this.disabled = true;
    }
  }
  public handleAddressChange(address) {
    for (var i = 0; i < address.address_components.length; i++) {
      var addressType = address.address_components[i].types[0];
      if (this.componentForm[addressType]) {
        var val =
          address.address_components[i][this.componentForm[addressType]];
        //
        switch (addressType) {
          case 'postal_code':
            this.data.Tiers_CP = val;
            break;
          case 'country':
            this.data.Tiers_Pays = val;
            break;
          case 'administrative_area_level_1':
            this.data.Tiers_Region = val;
            break;
          case 'locality':
            this.data.Tiers_Ville = val;
            break;
        }
      }
    }
  }

  httpGet(url) {
    this.generalService.rechercheTable(url).subscribe(
      (data) => {
        this.ds = data;
        this.data = data.Tiers[0];
        this.clientIsLoadet = true;

        if (!this.generalService.isNotEmpty(this.data.Tiers_TVA))
          this.data.Tiers_TVA = '';
        if (!this.generalService.isNotEmpty(this.data.Tiers_RS))
          this.data.Tiers_RS = '';
        if (!this.generalService.isNotEmpty(this.data.Tiers_NomPublic))
          this.data.Tiers_NomPublic = '';
        if (!this.generalService.isNotEmpty(this.data.Tiers_NAF))
          this.data.Tiers_NAF = '';
        if (this.generalService.isNotEmpty(this.data.Tiers_codeF))
          this.getEntiteDeFacturation(this.data.Tiers_codeF);
        if (!this.generalService.isNotEmpty(this.data.Tiers_Siret))
          this.data.Tiers_Siret = '';
        if (!this.generalService.isNotEmpty(this.data.Tiers_TVA))
          this.data.Tiers_TVA = '';
        if (!this.generalService.isNotEmpty(this.data.Tiers_Contact_Tel))
          this.data.Tiers_Contact_Tel = '';
        if (!this.generalService.isNotEmpty(this.data.Tiers_Contact_Mobile))
          this.data.Tiers_Contact_Mobile = '';
        if (!this.generalService.isNotEmpty(this.data.Tiers_CP))
          this.data.Tiers_CP = '';
        if (this.typeTrs != '1') this.getInterlocuteur();
        else {
          this.exist = true;
          this.data.Tiers_Type = this.typeClient;
        }
      },
      (error) => {}
    );
  }
  getEntiteDeFacturation(Tiers_codeF) {
    this.generalService
      .rechercheTable(this.generalService.urlClient + '&val=' + Tiers_codeF)
      .subscribe((data) => {
        this.selectedTiersFacturation = data.Tiers[0].Tiers_NomPublic;
      });
  }
  enregistrer() {
    //if (this.formIniformation.form.valid)
    {
      this.buttonDisabled = true;
      //verification existance client
      this.generalService
        .rechercheTable(
          this.generalService.urlListeClientByType + this.typeClient
        )
        .subscribe((listeClient) => {
          var findClient = listeClient.find((client) => {
            return (
              (client.Tiers_RS == this.data.Tiers_RS ||
                client.Tiers_NomPublic == this.data.Tiers_NomPublic ||
                client.Tiers_Siret == this.data.Tiers_Siret) &&
              client.Tiers_Code != this.data.Tiers_code
            );
          });
          if (!findClient) {
            this.exist = false;
            //enregistrement
            this.generalService.enregisterTable(this.ds).subscribe(
              (data) => {
                this.buttonDisabled = false;
                this.generalService.dialogSuccess('Enregisté', true);
                this.initVariable();
                if (this.typeTrs == '1') this.param_code = data.code;
                this.typeTrs = '2';
                this.getClient();
              },
              (err) => {
                this.generalService.dialogSuccess('Non enregisté', false);
                this.buttonDisabled = false;
                if (err.error instanceof Error) {
                } else {
                }
              }
            );
          } else {
            this.generalService.dialogSuccess(
              'Ce ' + this.typeClientText.toLowerCase() + ' existe déjà',
              false
            );
            this.buttonDisabled = false;
          }
        });
    }
    //else
    $('#btnHiddeb').trigger('click');
  }
  getActionClient() {
    this.generalService
      .rechercheTable(
        'recherche/tbdata?tablere=avtActionClient&param=' + this.param_code
      )
      .subscribe((data) => {
        this.listeActionComponen.setDataSource(data);
      });
  }
  getDocumentClient() {
    this.generalService
      .rechercheTable(
        'recherche/tbdata?tablere=avtdoce&param=' + this.param_code
      )
      .subscribe((data) => {
        var listeFacture = data.filter((fact) => {
          return fact.Doc_Type == 'FACT';
        });
        listeFacture = this.generalService.genererListeDocument(listeFacture);
        var listeDevis = data.filter((dev) => {
          return dev.Doc_Type == 'FACP';
        });
        this.listeFactureComponen.setDataSource(listeFacture);
        this.listeDevisComponen.setDataSource(listeDevis);
      });
  }
  readParamUrl() {
    this.route.params.subscribe((params) => {
      this.exist = false;
      this.index = 0;
      this.initVariable();
      this.param_code = params['param_code'];
      this.typeTrs = params['typeTrs'];
      this.typeClient = params['typeClient'];
      if (this.typeTrs != '3')
        this.listBtnInterlocuteur = this.list_Btn_Inter_locuteur;
      else this.listBtnInterlocuteur = [];
      if (!this.generalService.isNotEmpty(this.typeClient))
        this.typeClient = this.generalService.typeClient;
      this.getClient();
      this.showImage(this.param_code);
      this.getActionClient();
      this.getDocumentClient();
    });
  }
  retourListes() {
    this.generalService.popupCenter(
      '/w/avt/parametre/liste/clients/' + this.typeClient
    );

    // this.generalService.paramListeClient = this.typeClient;
    // this.generalService.dialogOpend = this.generalService.dialog.open(ListeClientsComponent, new MatDialogConfig());
    // this.exist = false;
    // this.generalService.dialogOpend.afterClosed().subscribe(() =>
    // {
    //   if( this.generalService.isNotEmpty( this.generalService.documentChoisie))
    //   {
    //     this.param_code = (this.generalService.documentChoisie.Tiers_Code);
    //     this.typeTrs = "2";
    //     this.getClient();
    //   }
    //   this.exist = true
    // });
    // this.router.navigate(['w/avt/parametre/liste/clients/'+this.typeClient]);
  }
  initVariable() {
    this.disabledEAlertes = true;
    this.disabledEDocuments = true;
    this.disabledEchanges = true;
    this.disabledInterlocuteur = true;
    this.showTabAlert = false;
    this.buttonDisabled = false;
    this.disabled = false;
    this.show = true;
  }
  onPaysChange(e) {
    var list = this.generalService.nationalitePays.filter((val) => {
      return (
        val.libelle.toLowerCase().indexOf(e.target.value.toLowerCase()) >= 0
      );
    });
    if (list.length == 0) {
      list = this.generalService.nationalitePays;
      e.target.value = e.target.value.substr(0, e.target.value.length - 1);
    }
    this.pays = list;
  }
  suivant(f, index) {
    if (f != undefined && f != null) {
      if (index == 1) {
        if (
          f.form.controls.Tiers_RS.valid &&
          f.form.controls.Tiers_NomPublic.valid &&
          f.form.controls.Tiers_Siret.valid &&
          f.form.controls.Tiers_MailPro.valid
        ) {
          this.index += 1;
        }
      } else if (index == 2) {
        if (
          f.form.controls.Tiers_CP.valid &&
          f.form.controls.Tiers_Ville.valid &&
          f.form.controls.Tiers_Region.valid &&
          f.form.controls.Tiers_Pays.valid
        ) {
          this.index += 1;
        }
      } else {
        this.index += 1;
      }
    } else {
      this.index += 1;
    }
  }

  removeNumberFromText(event) {
    event.currentTarget.value = this.generalService.removeNumberFromText(
      event.currentTarget.value
    );
    // setTimeout( () =>
    // {
    //   var myText = this.generalService.removeNumberFromText(text);
    //   var data = this.data;
    //   eval("data."+attribut+" = myText");
    // },1);
  }
  validerCodeNaf(event) {
    //suppression des caractere alphabetique du 4 premiére caractaire du Tiers_NAF
    var num: string = '';
    num = this.data.Tiers_NAF.substring(0, 4);
    if (num != null && num != '' && num != undefined)
      num = this.generalService.removeTextFromNumber(num);
    else num = '';

    //suppression des numéro du 5 emme caractaire du Tiers_NAF
    var text: string = '';
    text = this.data.Tiers_NAF.substring(4, 5);
    if (text != null && text != '' && text != undefined)
      text = this.generalService.removeNumberFromText(text);
    else text = '';

    setTimeout(() => {
      this.data.Tiers_NAF = num + text;
    }, 1);
  }
  removeTextFromNumber(event) {
    event.currentTarget.value = this.generalService.removeTextFromNumber(
      event.currentTarget.value
    );
    // //remove all char From Tiers_TVA
    // setTimeout( () =>
    // {
    //   this.data.Tiers_TVA = this.generalService.removeTextFromNumber(this.data.Tiers_TVA);
    // },1);
  }
  onTiersTypeChange(value) {
    this.typeClient = value;
    this.data.Tiers_Type = value;
    this.setTypeClientText();
  }
  loadAllApiIsFinish(): boolean {
    if (
      this.clientIsLoadet &&
      this.datasourceInterlocuteurIsLoadet &&
      this.columnsInterlocuteurIsLoadet
    )
      return true;
    else return false;
  }

  getInterlocuteur() {
    this.getDataInterlocuteur();
    this.getColumnsInterlocuteur();
  }
  getDataInterlocuteur() {
    this.generalService
      .rechercheTable(
        this.generalService.urlListeInterlocuteur + this.param_code
      )
      .subscribe((data) => {
        this.datasourceInterlocuteur = data;
        this.datasourceInterlocuteurIsLoadet = true;
        for (var i = 0; i < this.datasourceInterlocuteur.length; i++) {
          if (this.datasourceInterlocuteur[i].TiersC_Civilite == 0)
            this.datasourceInterlocuteur[i].TiersC_Civilite = 'Monsieur';
          else this.datasourceInterlocuteur[i].TiersC_Civilite = 'Madame';
        }
        if (this.columnsInterlocuteurIsLoadet) {
          this.showTabInterlocuteur = true;
          setTimeout(() => {
            this.listeInterlocuteurComponen.setDataSource(
              this.datasourceInterlocuteur
            );
            $('#hiddenBtnForActualiserListe').trigger('click');
          }, 10);
        }

        if (this.loadAllApiIsFinish()) this.exist = true;
      });
  }
  getColumnsInterlocuteur() {
    this.generalService
      .rechercheTable(this.generalService.urlColumnInterlocuteur)
      .subscribe((data) => {
        this.columnsInterlocuteur = data;
        this.columnsInterlocuteurIsLoadet = true;
        this.columnsInterlocuteur.TableRD.forEach((col) => {
          col.TableRD_ReadOnly = true;
        });
        this.showTabInterlocuteur = true;
        if (this.datasourceInterlocuteurIsLoadet) {
          setTimeout(() => {
            this.listeInterlocuteurComponen.setDataSource(
              this.datasourceInterlocuteur
            );
          }, 10);
        }
        if (this.loadAllApiIsFinish()) this.exist = true;
      });
  }

  clickBtnHeat(event) {
    switch (event.name) {
      case 'ajouter': {
        this.showInterlocuteur('-1');
        break;
      }
      case 'modifier': {
        this.showInterlocuteur(event.row.TiersC_Id);
        break;
      }
      case 'supprimer': {
        this.supprimerInterlocuteur(event.row);
        break;
      }
    }
  }

  //ne pas supprimer
  doNotThink() {
    console.log('doNotThink');
  }
  showInterlocuteur(TiersC_Id) {
    localStorage.setItem('interlocuteur', '');
    var windows = this.generalService.popupCenter(
      '/w/avt/Interlocuteur/' + TiersC_Id + '/' + this.param_code,
      700,
      400
    );
    windows.onbeforeunload = () => {
      var interlocuteur = localStorage.getItem('interlocuteur');
      if (this.generalService.isNotEmpty(interlocuteur)) {
        this.getDataInterlocuteur();
        this.generalService.dialogSuccess('Interlocuteur enregistrer', true);
      } else
        this.generalService.dialogSuccess(
          'Interlocuteur non enregistrer',
          false
        );
    };
  }
  animationDone() {
    if (this.index == 7) this.showDoc = true;
  }
  setOldIndex() {
    this.oldIndex = this.index;
  }
  tabChanged(event) {
    if (event.index > this.oldIndex && event.index == 1 && !this.disabled) {
      this.enregistrer();
      // if (this.formIniformation.form.valid)
      // {
      //   this.enregistrer()
      // }
      // else
      // {
      //   this.index = parseInt(this.oldIndex.toString())
      //   $("#btnHiddeb").trigger("click")
      // }
    }
  }
  supprimerInterlocuteur(row) {
    const dialogConfig = this.generalService.dialogConfig;
    dialogConfig.autoFocus = true;
    var dialogRef = this.generalService.dialog.open(
      AvtDialogDeleteComponent,
      dialogConfig
    );
    dialogRef.afterClosed().subscribe((result) => {
      if (result == 'supprimer') {
        var deleteFn = this.generalService.supprimerSanMsgConfirm(
          row.TiersC_Id,
          'tiersC'
        );
        if (deleteFn != null) {
          this.exist = false;
          this.listBtnInterlocuteur[2].disabled = true;
          deleteFn.subscribe(
            (data) => {
              this.getDataInterlocuteur();
              this.generalService.dialogSuccess('Elément supprimer', true);
              this.exist = true;
              this.listBtnInterlocuteur[2].disabled = false;
            },
            (error) => {
              this.generalService.dialogSuccess('Elément non supprimé', false);
              this.exist = true;
              this.listBtnInterlocuteur[2].disabled = false;
            }
          );
        }
      }
      if (result == 'annuler') {
      }
    });
  }
}
